import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import "../../styles/careerPageStyle.css"
import appLogo from '../../assets/logoFinal-removebg-preview.png';
import opening from "../../assets/openings.svg"
import { useDispatch, useSelector } from 'react-redux';
import { getCareerPageJobs } from '../services/operations/jobPostAPI';
import CustomPagination from './jobPostings/CustomPagination';
import Loader from '../Loader/Loader';

const EmbeddedJobs = () => {
  const [jobsData, setJobsData] = useState({ jobsList: [], company: '' });
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { token } = useParams();
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_page: 1,
    total: "",
    per_page: 10,
  });



  const getJobs = async (page = 1) => {
    const payload = { token };
    setLoading(true);
    const result = await dispatch(getCareerPageJobs(payload, pagination.per_page, page));

    if (result?.data?.data) {
      const allData = result.data.data;



      const jobList = Object.entries(allData)
        .filter(([key]) => !isNaN(Number(key)))
        .map(([_, value]) => value);

      const companyObj = allData.find(item => item.company);

      setJobsData({
        jobsList: jobList,
        company: companyObj?.company || 'Company',
      });
    }

    if (result?.data?.pagination) {
      setPagination((prev) => ({
        ...prev,
        current_page: page,
        per_page: result.data.pagination.per_page,
        total: result.data.pagination.total,
        total_page: result.data.pagination.last_page,
      }));
    }
    setLoading(false);
  };



  useEffect(() => {
    getJobs(pagination.current_page);
  }, [pagination.current_page]);


  const handlePageChange = (newPage) => {
    if (newPage !== pagination.current_page) {
      setPagination((prev) => ({
        ...prev,
        current_page: newPage,
      }));
    }
  };


  const handleViewJob = (id) => {
    const fullUrl = `/view-carrer-page-job/${id}/${jobsData.company}`;
    navigate(fullUrl)
  }


  return (
    <div className='career-page-container' style={{ minHeight: '100vh' }}>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className='career-page-navbar'>
            <div className='career-page-company-detail'>
              <p className='company-name-career-page'>
                <img src={opening} alt='openings' />
                <span>{jobsData.company}</span>
              </p>
              <p className='career-page-opening'>Current Openings</p>
            </div>
          </div>

          <div className='jobs-container'>
            {jobsData.jobsList.map((job, index) => {
              return (
                <div className='job-list' key={index}>
                  <p className='career-page-industry'>
                    {Array.isArray(job.industry)
                      ? job.industry.join(', ')
                      : JSON.parse(job.industry || '[]').join(', ')}
                  </p>

                  <hr />
                  {Array.isArray(job.jobs) && job.jobs.map((item, i) => {
                    return (
                      <div className='job-item' key={i}>
                        <p className='career-page-job-title'>{item.job_title}</p>
                        <p className='career-page-workplace'>{item.workplace_type}</p>
                        <p className='career-page-location'>{item.job_location}</p>
                        <p className='career-page-apply' onClick={() => handleViewJob(item.id)}>View Job</p>
                      </div>
                    );
                  })}
                </div>
              );
            })}

          </div>

          <div className='career-page-pagination'>
            {jobsData.jobsList.length > 0 && (
              <CustomPagination
                totalPages={pagination.total_page}
                currentPage={pagination.current_page}
                onPageChange={handlePageChange}
              />
            )}
          </div>

          <div className='career-page-company-footer'>
            <p className='career-page-opening' style={{ display: "flex", alignItems: "center" }}><span>Powered by</span><img src={appLogo} alt='app=logo' /></p>
          </div>
        </>
      )}
    </div>
  );


};

export default EmbeddedJobs;
